export const DEFAULT_PALETTE = {
  black: '#000000',
  white: '#FFFFFF',

  grey900: '#121212',
  grey800: '#1F1F1F',
  grey700: '#2D2D2D',
  grey600: '#5B5B5B',
  grey500: '#898989',
  grey400: '#B7B7B7',
  grey300: '#D5D5D5',
  grey200: '#E5E5E5',
  grey100: '#ECECEC',
  grey50: '#F4F4F4',
  grey10: '#FAFAFA',

  green900: '#022918',
  green700: '#045230',
  green600: '#077B48',
  green500: '#09A460',
  green400: '#0CCD78',
  green300: '#20F999',
  green200: '#AFFFC1',
  green100: '#DDFFE4',

  red900: '#5A0A00',
  red700: '#870F00',
  red600: '#AB1300',
  red500: '#E11900',
  red400: '#E85C4A',
  red300: '#F1998E',
  red200: '#FED7D2',
  red100: '#FFEFED',

  yellow900: '#674D1B',
  yellow700: '#997328',
  yellow600: '#DFA83D',
  yellow500: '#FFC043',
  yellow400: '#FFCF70',
  yellow300: '#FFE3AC',
  yellow200: '#FFF2D9',
  yellow100: '#FFFAF0',

  purple900: '#2E224C',
  purple700: '#453473',
  purple600: '#574191',
  purple500: '#7356BF',
  purple400: '#957FCE',
  purple300: '#C1B5E3',
  purple200: '#E3DDF2',
  purple100: '#F4F1FA',

  blue900: '#102C60',
  blue700: '#174291',
  blue600: '#1E54B7',
  blue500: '#276EF1',
  blue400: '#5B91F5',
  blue300: '#A0BFF8',
  blue200: '#D4E2FC',
  blue100: '#EFF3FE',

  pink900: '#250527',
  pink700: '#4B0A4F',
  pink600: '#701076',
  pink500: '#96159E',
  pink400: '#BC1BC6',
  pink300: '#D05FD7',
  pink200: '#E4A3E8',
  pink100: '#F8E8F9',
  pink50: '#FBF6FC',

  orange900: '#672A16',
  orange700: '#9A3F21',
  orange600: '#C14F29',
  orange500: '#FF6937',
  orange400: '#FA9269',
  orange300: '#FABDA5',
  orange200: '#FFE1D6',
  orange100: '#FFF3EF',

  brandAccent900: '#102C20',
  brandAccent700: '#215840',
  brandAccent600: '#328460',
  brandAccent500: '#43B080',
  brandAccent400: '#54DCA0',
  brandAccent300: '#87E6BC',
  brandAccent200: '#BAF1D9',
  brandAccent100: '#DCF8EC',
  brandAccent50: '#EDFBF5',
} as const;
